import type { EmojiCategoryList } from "@platejs/emoji";
import type { UseEmojiPickerType } from "@platejs/emoji/react";
import styles from "./emoji.module.scss";

export type EmojiPickerNavigationProps = {
  onClick: (id: EmojiCategoryList) => void;
} & Pick<
  UseEmojiPickerType,
  "emojiLibrary" | "focusedCategory" | "i18n" | "icons"
>;

export function EmojiPickerNavigation({
  emojiLibrary,
  focusedCategory,
  i18n,
  icons,
  onClick,
}: EmojiPickerNavigationProps) {
  return (
    <nav className={styles.emojiNavigation}>
      <div>
        {emojiLibrary
          .getGrid()
          .sections()
          .map(({ id }) => (
            <button
              key={id}
              onClick={() => {
                onClick(id);
              }}
              aria-label={i18n.categories[id]}
              className={id === focusedCategory ? styles.active : ""}
            >
              {icons.categories[id].outline}
            </button>
          ))}
      </div>
    </nav>
  );
}
